import React, { Component } from "react";
import { Row, Col, Form, FormControl, Button, Table } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import MessagesApi from "../api/messages.api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import Modal from "react-modal";
import Cookies from "js-cookie";

export default class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      totalCount: 10,
      searchText: "",
      currentMessageId: 0,
      modalIsOpen: false,
      messages: { rows: [], count: 0 },
      isSuperAdmin: (() => {
        try {
          return JSON.parse(Cookies.get("isSuperAdmin") || "false");
        } catch {
          return false;
        }
      })(),
    };

    this.getMessages = this.getMessages.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
    this.setCurrentMessage = this.setCurrentMessage.bind(this);
    this.renderMessageCell = this.renderMessageCell.bind(this);
  }

  componentDidMount() {
    // Set once to avoid accessibility warning spam
    Modal.setAppElement("#root");
    this.getMessages().catch(() =>
      toast.error("Грешка при превземањето на пораките")
    );
  }

  async getMessages(pageNumber) {
    try {
      const pageToLoad = pageNumber ? pageNumber : this.state.page;
      const result = await MessagesApi.getAllMessages(
        pageToLoad,
        this.state.totalCount,
        this.state.searchText
      );

      // Expecting result.messages = { rows: [...], count: n }
      const messages =
        result && result.messages
          ? {
              rows: Array.isArray(result.messages.rows)
                ? result.messages.rows
                : [],
              count:
                typeof result.messages.count === "number"
                  ? result.messages.count
                  : 0,
            }
          : { rows: [], count: 0 };

      this.setState({ messages, page: pageToLoad });
    } catch (error) {
      console.error(error);
      toast.error("Грешка при превземањето на пораките");
    }
  }

  async handlePageClick(e) {
    await this.getMessages(e.selected + 1);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    await this.getMessages(1); // reset to first page on new search
  }

  setCurrentMessage(messageId) {
    this.setState({
      currentMessageId: messageId,
      modalIsOpen: true,
    });
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  async deleteComment() {
    try {
      const result = await MessagesApi.deleteMessage(this.state.currentMessageId);
      if (result?.status === 200) {
        toast.success("Коментарот беше успешно избришан");
        this.setState({ currentMessageId: 0, modalIsOpen: false });
        this.getMessages();
      }
    } catch (error) {
      console.error(error);
      toast.error("Грешка при бришење коментар");
    }
  }

  // Safely render different message shapes
  renderMessageCell(i) {
    if (i.isPicture && i.url) {
      return (
        <img
          className="pointer thumbnail"
          src={i.url}
          onClick={() => window.open(i.url, "_blank")}
          alt="attachment"
        />
      );
    }

    const m0 = i?.messages?.[0];

    // Try multiple common shapes
    const raw =
      typeof m0 === "string" || typeof m0 === "number"
        ? m0
        : typeof m0?.message === "string" || typeof m0?.message === "number"
        ? m0.message
        : m0?.message?.text ?? m0?.text ?? null;

    if (raw != null) return String(raw);

    try {
      return JSON.stringify(m0?.message ?? m0);
    } catch {
      return "";
    }
  }

  render() {
    const customStyles = {
      content: {
        top: "30%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    const rows = this.state.messages?.rows ?? [];
    const total = this.state.messages?.count ?? 0;
    const pageCount = Math.max(
      1,
      Math.ceil(total / (this.state.totalCount || 10))
    );

    return (
      <Row className="table-section">
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Confirm delete"
          style={customStyles}
        >
          <Form>
            <Form.Group as={Row}>
              <Form.Label className="black">
                Дали сте сигурни дека сакате да го избришите коментарот ?
              </Form.Label>
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextPassword">
              <Button onClick={this.deleteComment} className="mr-2 btn btn-success">
                Да
              </Button>
              <Button onClick={this.closeModal} className="btn btn-danger">
                Откажи
              </Button>
            </Form.Group>
          </Form>
        </Modal>

        <ToastContainer />

        <Col lg={12}>
          <figure className="icon-group">
            <h2 className="heading ml-3">Коментари / Прашања</h2>
          </figure>

          <Form inline onSubmit={this.handleSubmit}>
            <FormControl
              type="number"
              name="searchText"
              placeholder="Пребарај тел.број"
              className="mr-sm-2"
              onChange={this.handleChange}
              value={this.state.searchText}
            />
            <Button variant="btn mr-2 button-standard" type="submit">
              <i className="material-icons">search</i>
              Пребарај
            </Button>
            <Button
              className="btn mr-2 button-standard"
              onClick={() => this.getMessages()}
              type="button"
            >
              <i className="material-icons">refresh</i> Освежи
            </Button>
          </Form>

          <section className="list-box mt-3">
            <Table responsive="xl" className="mb-5">
              <thead className="table-head">
                <tr>
                  <th>Испратил</th>
                  <th>Коментар/Прашање</th>
                  <th>Испратено на</th>
                  <th>Акција</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((i) => {
                  const date = i?.last_update
                    ? new Date(i.last_update).toLocaleString("en-GB")
                    : "";
                  return (
                    <tr key={i._id}>
                      <td>{i.viber_name}</td>
                      <td>
                        {i.last_update_from_user ? (
                          <i
                            className="material-icons pointer error"
                            title="Корисникот внесе коментар/прашање"
                          >
                            error
                          </i>
                        ) : null}
                        {this.renderMessageCell(i)}
                      </td>
                      <td>{date}</td>
                      <td>
                        <Link className="btn button-standard" to={`/messages/${i._id}`}>
                          <i className="material-icons">search</i>
                          Прегледај пораки
                        </Link>
                        {this.state.isSuperAdmin ? (
                          <Button
                            onClick={() => this.setCurrentMessage(i._id)}
                            className="btn btn-danger ml-2 delete-btn"
                          >
                            <i className="material-icons">delete</i>
                            Избриши
                          </Button>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <ReactPaginate
              previousLabel={"< Претходна"}
              nextLabel={"Следна >"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              containerClassName={"list-group-pagination pagination"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link z-index-0"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              disabledClassName={"page-item disabled"}
              activeClassName={"page-item active"}
              className="z-index-0"
              forcePage={Math.min(this.state.page - 1, pageCount - 1)}
            />
          </section>
        </Col>
      </Row>
    );
  }
}
